import { useResponsive } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";

import type { OutstreamAdUnit, Targeting } from "~/components/advertisement/ad-slots/types";
import { PrebidScripts } from "~/components/advertisement/prebid/scripts";

import { Slot } from "./slot";
import { Container } from "./styles";

export type Props = {
  adUnit: OutstreamAdUnit;
  breakpoint?: string;
  className?: string;
  divId?: string;
  isDisabled?: boolean;
  targeting?: Targeting;
  zone?: string | null;
};
export const OutstreamAdSlot: FunctionComponent<Props> = ({
  breakpoint = "",
  isDisabled,
  ...slotProps
}) => {
  const isBreakpoint = useResponsive(breakpoint, false);
  if (!isBreakpoint || isDisabled) return null;

  return (
    <Container>
      <PrebidScripts />
      <Slot {...slotProps} />
    </Container>
  );
};

OutstreamAdSlot.displayName = "OutstreamAdSlot";
